<template>
  <section>
    <div class="left">
      <div class="wrapper">
        <div>
          <p class="en">Color variation</p>
          <p class="ja"><strong>浴室空間をもっとお洒落で素敵な雰囲気に。</strong></p>
          <p class="ja is-pc">ツートン浴槽や天井・壁のカラーコーディネートを楽しむ</p>
          <div class="btn">
            <app-button path="/color-variation" name="詳しくみる" />
          </div>
        </div>
        <img src="/images/bg_tb_colorVariation.jpg" class="thumbnail">
      </div>
    </div>
    <div class="right"></div>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton.vue'

export default {
  name: 'SlideValiation',
  components: {
    AppButton
  }
}
</script>

<style scoped lang="scss">
section {
  display: flex;

  @include mq(tb) {
    display: block;
  }

  > div {
    width: calc(100% / 2);
    height: 50vw;
    background-size: cover;
    background-position: center center;
    @include flexCentering;

    @include mq(tb) {
      width: 100%;
      height: auto;
      padding: 48px 0;
    }

    &.left {
      background-image: url('/images/bg_tile.jpg');
      background-repeat: repeat-y;
    }

    &.right {
      background-image: url('/images/bg_colorVariation.jpg');

      @include mq(tb) {
        display: none;
      }
    }
  }

  .wrapper {
    background: #fff;
    width: 100%;
    padding: 7.5vw 0;
    text-align: center;

    @include mq(tb) {
      padding: 32px 0 0;
    }
  }

  .en {
    font-family: $bellFont;
    font-size: 36px;
    margin-bottom: 24px;

    @include mq(tb) {
      font-size: 27px;
    }
  }

  .ja {
    font-size: 13px;

    strong {
      font-size: 16px;
    }
  }

  p + p {
    margin-top: 16px;
  }

  .btn {
    width: $baseBtnSize;
    margin: 32px auto 0;
  }
}

.thumbnail {
  display: none;

  @include mq(tb) {
    display: block;
    width: 100%;
    margin-top: 32px;
  }
}
</style>